import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { common } from "../../copy/common";

export function Logo({ withText = true }: { withText?: boolean }) {
  return (
    <span className="inline-flex items-center gap-2 font-semibold text-foreground">
      <span aria-hidden="true" className="inline-flex size-7 items-center justify-center rounded-lg bg-primary shadow-[0_4px_12px_-4px_var(--primary)]">
        <span className="size-2.5 rounded-[3px] bg-primary-foreground" />
      </span>
      {withText && <span className="text-base tracking-tight">{common.brand}</span>}
    </span>
  );
}

/** Centered full-page message (UX_SPEC §10). One h1. */
export function FullPage({ icon, title, children, showLogo = true }: { icon?: ReactNode; title: ReactNode; children?: ReactNode; showLogo?: boolean }) {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      {showLogo && (
        <header className="flex h-14 items-center px-4 sm:px-6">
          <Link to="/" aria-label={common.logoLink} className="rounded-md">
            <Logo />
          </Link>
        </header>
      )}
      <main id="main" className="flex flex-1 items-start justify-center px-4 pt-[12vh] pb-16">
        <div className="flex w-full max-w-md flex-col items-center gap-4 text-center">
          {icon !== undefined && (
            <span aria-hidden="true" className="inline-flex size-12 items-center justify-center rounded-full bg-surface-2 text-muted-foreground">
              {icon}
            </span>
          )}
          <h1 className="text-2xl font-semibold">{title}</h1>
          {children}
        </div>
      </main>
    </div>
  );
}
